'use client';

import { FootprintForm } from '@/components/admin/footprints/FootprintForm';

export default function AdminFootprintNewPage() {
  return <FootprintForm />;
}
